import { AfterViewInit, Component, inject, viewChild } from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { MyDatePipe } from '../../../pipes/date.pipe'
import { AbstractUpcomingClass } from '../../../modal/class.modal'
import { AbstractRider, Volunteer } from '../../../modal/person.modal'
import { ApiDisabilityOption } from '../../../modal/api.modal'
import { VolunteerAttendance } from './volunteer-attendance/volunteer-attendance.component'
import { RiderAttendance } from './rider-attendance/rider-attendance.component'
import { RiderPairing } from './rider-pairing/rider-pairing.component'
import { ClassService } from '../../../services/class.service'
import { Modal } from 'bootstrap'
import { RiderDetail } from '../rider-detail/rider-detail.component'
import { AuthService } from '../../../services/auth.service'

@Component({
  selector: 'app-class-detail',
  imports: [
    Navbar,
    TranslatePipe,
    MyDatePipe,
    RiderDetail,
    VolunteerAttendance,
    RiderAttendance,
    RiderPairing
  ],
  templateUrl: './class-detail.component.html',
  styleUrl: './class-detail.component.css'
})
export class ClassDetail implements AfterViewInit {
  modal: Modal | undefined
  authService = inject(AuthService)
  classService = inject(ClassService)
  volAtteComp = viewChild(VolunteerAttendance)
  riderAtteComp = viewChild(RiderAttendance)
  riderPairComp = viewChild(RiderPairing)
  riderDetailComp = viewChild(RiderDetail)
  clazz?: AbstractUpcomingClass
  riders: AbstractRider[] = []
  volunteers: Volunteer[] = []
  isRidersLoading = true
  isCoach = false
  private disabilityOptions: ApiDisabilityOption[] = []
  private translateService = inject(TranslateService)

  constructor() {
    this.classService.getDisabilityOptions().subscribe({
      next: (options) => {
        this.disabilityOptions = [...options.physical, ...options.mental]
      },
      error: () => {}
    })
  }

  disabilityName(code: string): string {
    let option = this.disabilityOptions.find((o) => o.code === code)
    if (!option) {
      return code
    }
    switch (this.translateService.currentLang) {
      case 'zh-CN':
        return option.name_zh_cn
      case 'zh-HK':
        return option.name_zh_hk
      default:
        return option.name_en
    }
  }

  riderDisabilityLines(rider: AbstractRider): string[] {
    let lines: string[] = []
    if (rider.physicalDisabilities) {
      lines.push(
        ...rider.physicalDisabilities
          .split(',')
          .map((d) => this.disabilityName(d.trim()))
          .filter((d) => !!d)
      )
    }
    if (rider.physicalDisabilitiesOther) {
      lines.push(rider.physicalDisabilitiesOther)
    }
    if (rider.mentalDisabilities) {
      lines.push(
        ...rider.mentalDisabilities
          .split(',')
          .map((d) => this.disabilityName(d.trim()))
          .filter((d) => !!d)
      )
    }
    if (rider.mentalDisabilitiesOther) {
      lines.push(rider.mentalDisabilitiesOther)
    }
    return lines
  }

  getRiders() {
    if (!this.clazz?.id) {
      return
    }
    this.riders = []
    this.isRidersLoading = true
    this.classService.getClassRiders(this.clazz.id).subscribe({
      next: (riders) => {
        this.riders.push(...riders)
        this.isRidersLoading = false
      },
      error: (err) => {
        this.isRidersLoading = false
      }
    })
  }

  getVolunteers() {
    if (!this.clazz?.id) {
      return
    }

    this.isCoach = false
    this.volunteers = []
    this.classService.getClassVolunteers(this.clazz.id).subscribe((vols) => {
      this.volunteers.push(...vols.filter((vol) => !vol.isCoach))
      let userId = this.authService.getCurrentUser()?.id
      this.isCoach = vols.some((vol) => {
        if (vol.id === userId) {
          return !!vol.isCoach
        }

        return false
      })
    })
  }

  showRiderDetail(rider: AbstractRider) {
    this.riderDetailComp()?.show(this.clazz!, rider)
  }

  showVolunteerAttendance() {
    this.volAtteComp()?.show(this.clazz?.id!)
  }

  showRiderAttendance() {
    this.riderAtteComp()?.show(this.clazz?.id!)
  }

  showRiderPairing() {
    this.riderPairComp()?.show(this.clazz?.id!, this.riders)
  }

  show(clazz: AbstractUpcomingClass) {
    this.clazz = clazz
    this.modal?.show()
    this.getRiders()
    this.getVolunteers()
  }

  hide() {
    this.modal?.hide()
  }

  onPairingBack() {
    this.getRiders()
  }

  ngAfterViewInit(): void {
    this.modal = Modal.getOrCreateInstance('#classDetail')
  }
}
